import React, { useState } from "react";
import { createNewLead } from "../Apis/apis";
const initalState = {
  name: "", //done
  email: "", //done
  website: "", //done
  phonenumber: "", //done
  company: "", //company
  address: "", //done
  city: "", //city
  state: "", //done
  country: "", //done
  zip: "", //done
  description: "", //done
  leadstatus: "", //done
  leadsource: "", //done
  lastcontact: "", //lastcontact
  media_path_slug: "", // done
};
const CreateLead = ({ AssignLead, leadstatus, leadSource, setCreatelead,fetchPost }) => {

  const [update, setUpdate] = useState(initalState);
  const handleChange = async (e) => {
    const { name, value } = e.target;
    setUpdate({ ...update, [name]: value });
  };

  const createLead = async (e) => {
    e.preventDefault();
  
    // Check if all fields in update are filled
    const areAllFieldsFilled = Object.values(update).every((value) => value !== "");
  
    if (!areAllFieldsFilled) {
      alert("Please fill in all fields before submitting.");
      return;
    }
  
    const path = "/webleads";
    const data = await createNewLead(path, update);
  
    if (data.message === "You are not authorized for this Action") {
      alert(data.message);
    } else if (data.message === "Success") {
      setCreatelead(false);
      fetchPost();
    }
  };
  

  return (
    <div>
      <form onSubmit={createLead}>
        <div className="row ">
          <div className="d-flex justify-content-between my-2 pe-0">
      
            <select
              className="custom-select m-2 ms-0"
              name="leadstatus"
              onChange={handleChange}
            >
              <option disabled={true} selected>
                Status
              </option>
              {leadstatus.map((el) => (
                <option value={el.name}>{el.name}</option>
              ))}
            </select>

            <select
              className="custom-select m-2"
              id="leadsource"
              name="leadsource"
              onChange={handleChange}
            >
              <option disabled={true} selected>
                Source
              </option>
              {leadSource.map((el) => (
                <option value={el}>{el}</option>
              ))}
            </select>

            <select
              className="custom-select m-2 me-0"
              id="media_path_slug"
              name="media_path_slug"
              onChange={handleChange}
            >
              <option disabled={true} selected>
                Assigned{" "}
              </option>

              {AssignLead.map((el) => (
                <option value={el.media_path_slug}>{el.media_path_slug}</option>
              ))}
            </select>
            <span className="edit-btn" onClick={(e) => setCreatelead(false)}>
        Back
      </span>
          </div>
          <div className="col-6  text-start">
            <label for="Name">Name :</label>
            <input
              className=" form-control mt-1 ms-0"
              id="Name"
              name="name"
              type="text"
              // placeholder="name"
              onChange={handleChange}
            />
            <label for="Address">Address :</label>
            <input
              className=" form-control mt-1 ms-0"
              id="Address"
              name="address"
              type="text"
              // placeholder="Address"
              onChange={handleChange}
            />
            <label for="Email_Address">Email :</label>
            <input
              className=" form-control mt-1 ms-0 mb-2"
              id="Email_Address"
              type="email"
              name="email"
              // placeholder="email address"
              onChange={handleChange}
            />
            <label for="Phone">Phone :</label>
            <input
              className=" form-control mt-1 ms-0"
              id="Phone"
              type="number"
              // placeholder="phone number"
              name="phonenumber"
              onChange={handleChange}
            />
          </div>

          <div className="col-6 me-0 pe-0 mb-2">
            <label for="City">City :</label>
            <input
              id="City"
              type="text"
              className=" form-control mt-1 ms-0 me-0"
              name="city"
              // placeholder="city"
              onChange={handleChange}
            />
            <label for="Country">Country :</label>
            <input
              id="Country"
              type="text"
              className=" form-control mt-1 ms-0"
              name="country"
              // placeholder="Country"
              onChange={handleChange}
            />
            <label for="State">State :</label>
            <input
              id="State"
              type="text"
              className=" form-control mt-1 ms-0"
              name="state"
              // placeholder="State"
              onChange={handleChange}
            />
            <label for="Zip_Code">Zip_Code :</label>
            <input
              className=" form-control mt-1 ms-0"
              id="Zip_Code"
              type="number"
              name="zip"
              // placeholder="Zip_Code"
              onChange={handleChange}
            />
          </div>
          <br className="mt-2" />
          <label for="Company">Company :</label>
          <input
            className=" form-control mt-1"
            id="Company"
            type="text"
            name="company"
            // placeholder="Company"
            onChange={handleChange}
          />
          {/* <label  for="Website">Website </label>
            <input id='Website' type="url" name='website'  placeholder='Website' onChange={handleChange}/> */}
          <label for="Website">Website :</label>
          <input
            id="Website"
            className=" form-control mt-1"
            type="text"
            name="website"
            // placeholder="Website"
            onChange={handleChange}
          />
          <label for="Description">Description :</label>
          <input
            id="Description"
            className=" form-control mt-1"
            type="text"
            name="description"
            // placeholder="Description"
            onChange={handleChange}
          />
          <label for="Last_Contact">Last_Contact : </label>
          <input
            id="Last_Contact"
            type="text"
            name="lastcontact"
            className=" form-control mt-1 "
            // placeholder="Last_Contact"
            onChange={handleChange}
          />
          <div className="d-flex justify-content-center my-2">
            <input className="w-50" type="submit" value="Save" />
          </div>
   
        </div>
      </form>
    </div>
  );
};

export default CreateLead;
